"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Hero() {
  return <section data-section-id="214560" id="hero-datenschutz" className="relative w-full bg-background text-foreground py-32 flex items-center justify-center min-h-[85vh] overflow-hidden">
      {/* Hintergrundbild */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628971/img/hero_forest_privacy.png)] opacity-30" aria-hidden="true" />
      
      {/* Sanfter Overlay-Farbton */}
      <div className="absolute inset-0 z-10 bg-primary/5" aria-hidden="true" />

      {/* Content */}
      <div className="relative z-20 w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center flex flex-col items-center">
        <h1 className="font-default text-[48px] md:text-[72px] font-light tracking-wider text-foreground leading-[1.1] mb-6">
          Klarheit & <span className="italic text-primary font-semibold">Schutz</span>
        </h1>
        <p className="text-muted-foreground font-sans text-lg md:text-xl max-w-2xl mx-auto leading-relaxed font-light mb-12 uppercase tracking-[0.2em]">
Datenschutz und Ihre Sicherheit</p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center w-full sm:w-auto">
          <Button asChild className="rounded-full bg-primary hover:bg-primary/90 text-primary-foreground h-14 px-8 text-[18px] font-medium w-full sm:w-auto border-none shadow-md">
            
          </Button>
          
          <Button asChild variant="outline" className="rounded-full border-primary/40 text-foreground hover:bg-primary/10 hover:text-foreground h-14 px-8 text-[18px] font-medium bg-transparent w-full sm:w-auto">
            
          </Button>
        </div>
      </div>
    </section>;
}